import { GameMusic, Playlist } from '@repo/types'
import { Container, Heading, Panel } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'

import { AppHeader } from '@/components/AppHeader'
import { BackButton, CloseButton } from '@/components/icon-buttons/IconButtons'
import { Main } from '@/components/Main'
import { Page } from '@/components/Page'
import { PageHeading } from '@/components/PageHeading'
import { useUpdateUserPlaylist } from '@/pages/playlists/playlist-queries/user-playlists/useUpdateUserPlaylist'
import { updateGameSetting } from '@/store/game/updateGameDocument'
import StoreService from '@/store/StoreService'

import {
  JumbotronDefaultVideoFormValues,
  JumbotronDefaultVideoForm
} from './JumbotronDefaultVideoForm'

export const JumbotronDefaultVideoMusic = observer(() => {
  const { currentGame } = StoreService.getStore()
  const history = useHistory()

  if (!currentGame || currentGame.gameData.type !== 'music') {
    return null
  }

  const gameData = currentGame.gameData as GameMusic
  const playlistId = gameData.sourcePlaylistMeta.id

  const { mutate: updateUserPlaylist } = useUpdateUserPlaylist({ playlistId })

  const currentValues = {
    video: gameData.sourcePlaylistMeta.video?.url,
    videoPreGame: gameData.sourcePlaylistMeta.videoPreGame?.url
  }

  const handleClickBack = () => {
    history.goBack()
  }

  const handleClickClose = () => {
    history.push('/game')
  }

  const handleSubmit = async (values: JumbotronDefaultVideoFormValues) => {
    if (!currentGame || currentGame.gameData.type !== 'music') return

    const updates = {
      ...currentValues,
      ...values
    }

    const update = {
      ['sourcePlaylistMeta.video.url']: updates.video,
      ['sourcePlaylistMeta.videoPreGame.url']: updates.videoPreGame
    }

    await updateGameSetting(currentGame.gameId, update)

    const updatedPlaylist: Playlist = {
      ...gameData.sourcePlaylistMeta,
      video: {
        url: updates.video
      },
      videoPreGame: {
        url: updates.videoPreGame
      }
    }

    updateUserPlaylist(updatedPlaylist)
  }

  const handleSuccess = () => {
    history.push('/game')
  }

  return (
    <Page title='Jumbotron Videos'>
      <AppHeader
        actionsLeft={<BackButton onClick={handleClickBack} />}
        actionsRight={<CloseButton onClick={handleClickClose} />}
        header={<PageHeading>Jumbotron Settings</PageHeading>}
      />

      <Main>
        <Container size='medium'>
          <Panel className='flex flex-col gap-6'>
            <Heading>Videos</Heading>

            <JumbotronDefaultVideoForm
              onSubmit={handleSubmit}
              onSuccess={handleSuccess}
              {...currentValues}
            />
          </Panel>
        </Container>
      </Main>
    </Page>
  )
})
